export default function formatSwedishPhoneNumber(phoneNumber) {
	if (!phoneNumber) return phoneNumber;

	phoneNumber = phoneNumber.replace(/\D/g, "");

	if (phoneNumber.startsWith("0046")) {
		phoneNumber = phoneNumber.substring(4);
	} else if (phoneNumber.startsWith("+46")) {
		phoneNumber = phoneNumber.substring(3);
	} else if (phoneNumber.startsWith("46")) {
		phoneNumber = phoneNumber.substring(2);
		phoneNumber = "0" + phoneNumber;
	}

	if (phoneNumber.length === 10) {
		return phoneNumber.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "$1-$2 $3 $4");
	} else if (phoneNumber.length === 9) {
		return phoneNumber.replace(/(\d{3})(\d{2})(\d{2})/, "$1-$2 $3");
	} else {
		return phoneNumber;
	}
}
